import { Version } from "@single-js/common/util/version";
import { from, merge, of } from "rxjs";
import { logError, NonLoggableError } from "util/logging";
import { makeActionCreator } from "worker/api/helpers";
const LATEST_URL = "https://release.memsql.com/production/index/memsqlserver/latest.json"; //TODO: retitle memsqlserver
const LATEST_STUDIO_URL = "https://release.memsql.com/production/index/memsqlstudio/latest.json"; //TODO: retitle memsqlstudio
function fetchLatestMemsqlVersion() {
    return fetch(LATEST_URL)
        .then((response) => response.json())
        .then((json) => ({
        version: Version.fromString(json.version),
    }), (res) => {
        throw new NonLoggableError(res);
    });
}
function fetchLatestStudioVersion() {
    return fetch(LATEST_STUDIO_URL)
        .then((response) => response.json())
        .then((json) => ({
        version: Version.fromString(json.version),
    }), (res) => {
        throw new NonLoggableError(res);
    });
}
const createLatestMemsqlVersionAction = (data) => {
    return {
        type: "LATEST_MEMSQL_VERSION",
        error: false,
        payload: {
            loading: false,
            data,
        },
    };
};
const createLatestStudioVersionAction = (data) => {
    return {
        type: "LATEST_STUDIO_VERSION",
        error: false,
        payload: {
            loading: false,
            data,
        },
    };
};
export const queryLatestMemsqlVersion = makeActionCreator({
    name: "queryLatestMemsqlVersion",
    handle: () => {
        const $loading = of({
            type: "LATEST_MEMSQL_VERSION",
            error: false,
            payload: { loading: true },
        });
        const $compute = from(fetchLatestMemsqlVersion()
            .then(createLatestMemsqlVersionAction)
            .catch((err) => {
            logError(err);
            return {
                type: "LATEST_MEMSQL_VERSION",
                error: true,
                payload: err.message,
            };
        }));
        return merge($loading, $compute);
    },
});
export const queryLatestStudioVersion = makeActionCreator({
    name: "queryLatestStudioVersion",
    handle: () => {
        const $loading = of({
            type: "LATEST_STUDIO_VERSION",
            error: false,
            payload: { loading: true },
        });
        const $compute = from(fetchLatestStudioVersion()
            .then(createLatestStudioVersionAction)
            .catch((err) => {
            logError(err);
            return {
                type: "LATEST_STUDIO_VERSION",
                error: true,
                payload: err.message,
            };
        }));
        return merge($loading, $compute);
    },
});
